import store from '../store/store';

export function getFormIdForCurrentCommand(): string | null {
    return store.formId ?? null;
}
